const routes = {
	home: "/",
	contact: "mailto:sales@impilo.health",
	terms: "/terms",
	privacy: "/privacy",
	requestDemo: "/request-demo",
	blog: "/blog",
	about: "/about",
	solutions: "/solutions",
	clinicRpm: "/solutions/clinic-rpm",
	digitalHealthLogistics: "/solutions/digital-health-logistics",
	supportCrm: "/solutions/support-crm",
	techEnabledServices: "/solutions/tech-enabled-services",
	directToPatient: "/solutions/direct-to-patient",
	impiloPlatform: "/solutions/impilo-platform",
	useCasesVirtualCare: "/use-cases/virtual-care-companies",
	useCasesHealthPlans: "/use-cases/health-plans-and-payers",
	useCasesHealthSystems: "/use-cases/health-systems-and-msos",
	useCasesValueBasedCare: "/use-cases/value-based-care",
	useCasesPhysicians: "/use-cases/physicians-and-provider-groups",
	useCasesOems: "/use-cases/oems",
	integration: "/integrations",
	integrations: "/integrations",
	docs: "https://docs.impiloplatform.com",
}

const socials = {
	linkedin: "https://www.linkedin.com/company/impilo-inc/",
	careers: "https://careers.impilo.health",
	phone: "tel:+12028385839",
}

const links = {
	...routes,
	...socials,
}

export default links
